module.exports = __webpack_public_path__ + "img/retribution.d208739d.jpg";